import { ErrorMonitoringService } from './../error-monitoring/error-monitoring.service';
import { WalletService } from './../wallet/wallet.service';
import { Router } from '@angular/router';
import { CustomAlertComponent } from './../../components/custom-alert/custom-alert.component';
import { OpenModalGuardService } from './../open-modal-guard/open-modal-guard.service';
import { ModalController } from '@ionic/angular';
import { Observable } from 'rxjs';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DebtorGuardService {

  isDebtor = false;
  walletId: string;
  paymentId: string;

  constructor(
    private modalController: ModalController,
    private openModalGuardService: OpenModalGuardService,
    private router: Router,
    private walletService: WalletService,
    private errorMonitoringService: ErrorMonitoringService
  ) { }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | boolean {
    if (this.isDebtor) {
      this.openModalPayment();
    }
    return !this.isDebtor;
  }

  /* Valida si tiene un pago pendiente */
  validateDebtor(user: string) {
    /* Consulta las billeteras del usuario */
    this.walletService.getWalletsWithoutObservable(user).subscribe( async wallets => {
      this.isDebtor = false;
      /* Consulta si tiene algún pago creado o fallido */
      for (const wallet of wallets.docs) {
        const createdPayments = await this.validateCreatedPayments(wallet.id);
        /* Si tiene algun pago */
        if (createdPayments.length > 0) {
          this.walletId = wallet.id;
          this.paymentId = createdPayments[0].id;
          this.isDebtor = true;
          break;
        }
        const failedPayments = await this.validateFailedPayments(wallet.id);
        /* Si debe algun pago */
        if (failedPayments.length > 0) {
          this.walletId = wallet.id;
          this.paymentId = failedPayments[0].id;
          this.isDebtor = true;
          break;
        }
      }
    }, error => {
      this.isDebtor = false;
      this.errorMonitoringService.sendError(error, 'loadWallets in debtor service');
    });
  }

  /* Valida los pagos creados de una billetera */
  async validateCreatedPayments(wallet: string) {
    return this.walletService.getWalletPaymentsByState(wallet, 'created').toPromise().then( payments => {
      return payments.docs;
    }).catch( err => {
      this.errorMonitoringService.sendError(err, 'validateCreatedPayments in debtor service');
      return [];
    });
  }

  /* Valida los pagos fallidos de una billetera */
  async validateFailedPayments(wallet: string) {
    return this.walletService.getWalletPaymentsByState(wallet, 'failed').toPromise().then( payments => {
      return payments.docs;
    }).catch( err => {
      this.errorMonitoringService.sendError(err, 'validateFailedPayments in debtor service');
      return [];
    });
  }

  /* Abre el modal de deudor */
  async openModalPayment() {
    // indica que se debe bloquear/desbloquear la navegacion
    this.openModalGuardService.setModalOpen(true);

    const openModal = await this.modalController.create({
      component: CustomAlertComponent,
      cssClass: 'custom-alert-small',
      componentProps: {
        icon: 'billetera-alert',
        title: '¡Ponte al día!',
        subtitle: '',
        message: `Tienes servicios pendientes de pago,
          ponte al día o contáctate con soporte para agendar un nuevo servicio.`,
        buttons: [
          {
            text: 'Pagar',
            fill: 'solid',
            color: 'primary',
            action: 'pay'
          }
        ]
      },
      backdropDismiss: false
    });
    openModal.onDidDismiss().then( data => {
      // indica que se debe bloquear/desbloquear la navegacion
      this.openModalGuardService.setModalOpen(false);
      if (data.data.action === 'pay') {
        this.router.navigate(['billetera', this.walletId, 'movimientos', 'pago', this.paymentId]);
      } else {
        this.router.navigate(['']);
      }
    });
    // presenta el modal con el login
    return await openModal.present();
  }

}
